
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Power, DollarSign, FileText } from "lucide-react";

interface CardBasicInfoFieldsProps {
  titulo: string;
  potenciaKwp: string;
  valorVenda: string;
  valorKit: string;
  descricao: string;
  onTituloChange: (value: string) => void;
  onPotenciaChange: (value: string) => void;
  onValorVendaChange: (value: string) => void;
  onValorKitChange: (value: string) => void;
  onDescricaoChange: (value: string) => void;
}

export const CardBasicInfoFields = ({
  titulo,
  potenciaKwp,
  valorVenda,
  valorKit,
  descricao,
  onTituloChange,
  onPotenciaChange,
  onValorVendaChange,
  onValorKitChange,
  onDescricaoChange
}: CardBasicInfoFieldsProps) => {
  return (
    <>
      <div className="grid gap-2">
        <Label htmlFor="title">Título</Label>
        <Input 
          id="title" 
          value={titulo} 
          onChange={(e) => onTituloChange(e.target.value)}
          placeholder="Ex: Instalação Residencial"
          className="transition-all duration-200"
        />
      </div>
      
      <div className="grid gap-2">
        <Label htmlFor="potencia" className="flex items-center gap-2">
          <Power className="h-4 w-4" />
          Potência (kWp)
        </Label>
        <Input 
          id="potencia" 
          value={potenciaKwp} 
          onChange={(e) => onPotenciaChange(e.target.value)}
          placeholder="Ex: 5.76"
          className="transition-all duration-200"
        />
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="grid gap-2">
          <Label htmlFor="valorVenda" className="flex items-center gap-2">
            <DollarSign className="h-4 w-4" />
            Valor da Venda
          </Label>
          <Input 
            id="valorVenda" 
            value={valorVenda}
            onChange={(e) => onValorVendaChange(e.target.value)}
            placeholder="Ex: 45000"
            className="transition-all duration-200"
          />
        </div>
        
        <div className="grid gap-2">
          <Label htmlFor="valorKit" className="flex items-center gap-2">
            <DollarSign className="h-4 w-4" />
            Valor do Kit
          </Label>
          <Input 
            id="valorKit" 
            value={valorKit}
            onChange={(e) => onValorKitChange(e.target.value)}
            placeholder="Ex: 30000"
            className="transition-all duration-200"
          />
        </div>
      </div>
      
      <div className="grid gap-2">
        <Label htmlFor="descricao" className="flex items-center gap-2">
          <FileText className="h-4 w-4" />
          Descrição
        </Label>
        <Textarea 
          id="descricao" 
          value={descricao}
          onChange={(e) => onDescricaoChange(e.target.value)}
          placeholder="Detalhes sobre o projeto"
          className="transition-all duration-200"
        />
      </div>
    </>
  );
};
